// Reducer for Data Products: create, update, view, fetch detail
import {
  SET_DATA_PRODUCT_FIELD,
  CREATE_DATA_PRODUCT,
  UPDATE_DATA_PRODUCT,
  GET_DATA_PRODUCT,
  RESET_DATA_PRODUCT,
  SET_DATA_PRODUCT_FIELD_ERROR,
  SET_DATA_PRODUCT_LOADER,
} from '../../constants/reducerTypes';

const initialState = {
  dataProductItem: {},
  dpStatus: 'draft',
  createDP: { status: null, response: null, actionType: null },
  getDP: { status: null },
  updateDP: { status: null, response: null, actionType: null },
  fieldErrors: {},
  dpLoading: false,
};

export default function dataProductReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA_PRODUCT_FIELD:
      return {
        ...state,
        dataProductItem: {
          ...state.dataProductItem,
          [action.payload.field]: action.payload.value,
        },
      };
    case SET_DATA_PRODUCT_LOADER:
      return {
        ...state,
        dpLoading: action.payload.loader,
      };
    case SET_DATA_PRODUCT_FIELD_ERROR:
      return {
        ...state,
        fieldErrors: action.payload.fieldErrors,
      };
    case CREATE_DATA_PRODUCT:
      return {
        ...state,
        createDP: {
          status: action?.payload?.status,
          response: action?.payload?.response,
          actionType: action?.payload?.actionType,
        },
      };
    case UPDATE_DATA_PRODUCT:
      return {
        ...state,
        updateDP: {
          status: action?.payload?.status,
          response: action?.payload?.response,
          actionType: action?.payload?.actionType,
        },
      };
    case GET_DATA_PRODUCT:
      return {
        ...state,
        dpLoading: false,
        dataProductItem: action?.payload?.item,
        dpStatus: action?.payload?.dpStatus,
        getDP: {
          getDPStatus: action?.payload?.status,
        },
      };
    case RESET_DATA_PRODUCT:
      return initialState;
    default:
      return state;
  }
}
